export function isPreSignedUrl(url: string | undefined): boolean {
  if (!url) {
    return false;
  }

  try {
    return new URL(url).searchParams.has("X-Amz-Signature");
  } catch (e) {
    return false;
  }
}
